import { render } from "./IndexModule.vue?vue&type=template&id=95f6aaf2"
import script from "./IndexModule.vue?vue&type=script&lang=js"
export * from "./IndexModule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__